<template>
	<div :class="form[this.property.name].length ? 'hasOptions' : ''">
		<el-button plain @click="addToInputList" style="width: 100%; margin-bottom: 10px" type="primary">
			{{ property.typeOptions.multipleValueButtonText || "Add Value" }}
		</el-button>
		<span :key="i" v-for="(value, i) in form[property.name]">
			<div style="display: inline-flex; align-items: center; width: 100%">
				<el-input
					style="margin-bottom: 10px; margin-top: 10px"
					autocomplete="new-password"
					:show-password="property.typeOptions && property.typeOptions.password ? true : false"
					:placeholder="property.placeholder || ''"
					v-model="form[property.name][i]"
				></el-input>
				<span style="margin-left: 10px">
					<el-button
						class="remove"
						@click="removeFromInputList(i)"
						type="danger"
						icon="el-icon-delete"
						circle
					></el-button>
				</span>
			</div>
		</span>
	</div>
</template>

<script>
export default {
	props: { property: Object, form: Object },
	beforeMount() {
		if (!this.form[this.property.name].length) {
			this.form[this.property.name].push("");
		}
	},
	methods: {
		addToInputList() {
			this.form[this.property.name].push("");
		},
		removeFromInputList(index) {
			for (var i = this.form[this.property.name].length - 1; i >= 0; i--) {
				if (i === index) {
					this.form[this.property.name].splice(index, 1);
					break;
				}
			}
		},
	},
};
</script>

<style scoped>
.remove {
	padding: 8px;
}

.hasOptions {
	border: 1px dashed #210f3c;
	padding-left: 10px;
	padding-right: 10px;
	padding-top: 10px;
	border-radius: 4px;
}
</style>
